import React from "react";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import ReactPlayer from "react-player";
import { CommunityFeedType } from "../../types";
import { GoFileMedia } from "react-icons/go";

type MediaProps = {
  feedMedias: CommunityFeedType[] | null;
};

const Media: React.FC<MediaProps> = ({ feedMedias }) => {
  if (!feedMedias) {
    return null; // Return early if feedMedias is null
  }

  const allMediaUrls: string[] = [];

  feedMedias.forEach((media) => {
    if (media.mediaUrl) {
      media.mediaUrl.forEach((url) => {
        if (url.imageUrl) {
          allMediaUrls.push(...url.imageUrl);
        }
        if (url.videoUrl) {
          allMediaUrls.push(...url.videoUrl);
        }
      });
    }
  });
  // if (allMediaUrls === null) {
  //   return <div>No media available</div>; // Handle null or undefined case
  // }

  const videos = feedMedias.flatMap((media) =>
    media.mediaUrl.flatMap((vide) => vide.videoUrl)
  );

  // Filter video URLs from allMediaUrls
  const videoURLs = allMediaUrls.filter((url) => videos.includes(url));
  let videoHash: string, thumbnailHash: string;

  return (
    <div className="flex w-full bg-white p-1 overflow-hidden">
      {allMediaUrls.length > 0 ? (
        <div className="grid lg:grid-cols-3 pb-5 lg:pb-2 h-full bg-white px-[2%] lg:px-0 pt-[23px] lg:pt-0 grid-cols-2 lg:bg-inherit gap-2 w-full overflow-hidden">
          {allMediaUrls &&
            allMediaUrls.map((media, index) => {
              const ipfsHashes = media.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [videoHash, thumbnailHash] = ipfsHashes;
              }
              return (
                media !== null && (
                  <div
                    className="h-[199px] lg:h-[258px] shadow overflow-hidden"
                    key={index * 2}
                  >
                    {videoURLs.includes(media) ? (
                      <ReactPlayer
                        key={index}
                        url={ipfsGatewayImage(videoHash)}
                        width="100%"
                        height="100%"
                        controls={true}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(thumbnailHash)}
                      />
                    ) : (
                      <img
                        id={`imga-${index}`}
                        src={ipfsGatewayImage(media)}
                        alt={`Media ${index}`}
                        className="w-full h-full object-cover object-center"
                      />
                    )}
                  </div>
                )
              );
            })}
        </div>
      ) : (
        <div className="w-full flex items-center justify-center h-32 font-Poppins text-lightBlack text-center text-3xl">
          <GoFileMedia />
          No media available
        </div>
      )}
    </div>
  );
};

export default Media;
